import React from "react";  
import { Box, LinearProgress, useTheme } from "@mui/material";

// Function to interpolate color between red and green
function interpolateColor(startColor, endColor, factor) {
  const hexToRgb = (hex) => hex.match(/.{2}/g).map((x) => parseInt(x, 16));
  const rgbToHex = (rgb) =>
    rgb
      .map((x) => x.toString(16).padStart(2, "0"))
      .join("")
      .toUpperCase();

  const s = hexToRgb(startColor.slice(1)); // Convert hex to RGB
  const e = hexToRgb(endColor.slice(1));  // Convert hex to RGB

  const result = s.map((start, i) => Math.round(start + factor * (e[i] - start)));
  return `#${rgbToHex(result)}`; // Convert RGB back to hex
}

const LoadingBar = ({ time, maxTime, sx={} }) => {
  const percent = 100 - (time / maxTime) * 100; // Reverse progress (from full to empty)
  const theme = useTheme();

  // Interpolate color from red to green based on progress
  const color = interpolateColor(theme.palette.error[700], theme.palette.success[400], time / maxTime);

  return (
    <Box sx={{ flex: 1, position: "relative", border: `1px solid ${theme.palette.primary[600]}`, borderRadius: 4, ...sx }}>
      <LinearProgress
        variant="determinate"
        value={percent} // Use reversed percent
        sx={{
          height: 8,
          borderRadius: 2,
          backgroundColor: theme.palette.primary[200], // Light background for the bar
          "& .MuiLinearProgress-bar": {
            backgroundColor: color, // Color changes based on time
            borderRadius: 2,
            transition: "width 0.2s linear, background-color 0.2s linear",
          },
        }}
      />
    </Box>
  );
};

export default LoadingBar;